import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import MenuSection from "@/components/MenuSection";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import Reservation from "@/components/Reservation";
import LocationSection from "@/components/LocationSection";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <div className="grain-overlay" aria-hidden="true" />
      <Toaster position="bottom-right" theme="dark" richColors />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <MenuSection />
        <Gallery />
        <Reviews />
        <Reservation />
        <LocationSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
